module.exports = __webpack_public_path__ + "assets/images/pages/listarobinson/listarobinson-1.webp?05c3adc2";